import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import { withTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import withDefaultAppContexts, {
  useDefaultAppContexts,
} from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import * as TopicsActions from 'hb-react/shared/apps/Topics/actions/topics';
import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import { getPageTitleFromNetwork } from 'hb-react/shared/utils/getPageTitleFromNetwork';

import Description from './Components/Description';
import EventsWrapper from './Components/EventsWrapper';
import ExpertsWrapper from './Components/ExpertsWrapper';
import HtmlBlock from './Components/HtmlBlock';
import NewsWrapper from './Components/NewsWrapper';
import PartnersWrapper from './Components/PartnersWrapper';

import style from './index.module.scss';

const getBgColor = (input) => input || 'var(--color-background, #fff)';

const TopicHomeContainer = ({
  currentUser,
  expert_store: expertStore,
  linked_event_store: linkedEventStore,
  partner_store: partnerStore,
  topic,
  whitelabelURL,
}) => {
  const { currentNetwork } = useDefaultAppContexts();

  const title = usePageMenuName(PAGES.HOMEPAGE, __('Home'));

  return (
    <div
      className={`soft--top ${style['side-container--infos']} `}
      data-testid="topic-home-container"
    >
      <DocumentTitle
        title={generatePageTitle({
          networkName: getPageTitleFromNetwork(currentNetwork),
          title,
          topicName: topic?.name,
        })}
      />
      <Description currentUser={currentUser} topic={topic} />
      {topic.home_config && (
        <>
          <HtmlBlock topic={topic} getBgColor={getBgColor} />

          <NewsWrapper
            getBgColor={getBgColor}
            topic={topic}
            whitelabelURL={whitelabelURL}
          />

          <EventsWrapper
            getBgColor={getBgColor}
            linkedEventStore={linkedEventStore}
            topic={topic}
            whitelabelURL={whitelabelURL}
          />

          <PartnersWrapper
            currentUser={currentUser}
            getBgColor={getBgColor}
            partnerStore={partnerStore}
            topic={topic}
          />
          <ExpertsWrapper
            topic={topic}
            currentUser={currentUser}
            expertStore={expertStore}
          />
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  partner_store: state.partners,
  expert_store: state.experts,
  linked_event_store: state.linked_events,
});

const mapDispatchToProps = (dispatch) => ({
  topics_actions: bindActionCreators(TopicsActions, dispatch),
});

export default compose(
  withDefaultAppContexts,
  withTopicContext,
  connect(mapStateToProps, mapDispatchToProps),
)(TopicHomeContainer);
